import request from '@/utils/request'

export function fetchPrinterList() {
  return request({
    url:'printer/list/',
    method:'get',
  })
}